// 동료 기본 설정
const CompanionsConfig = {
  ROGUE: {
    NAME: "궁수",
    MOVE_SPEED: 0.04, // 플레이어보다 약간 느림
    COLLIDER_RADIUS: 0.4,
    ATTACK_RANGE: 12.0, // 궁수니까 원거리 공격
    ATTACK_ANGLE: Math.PI / 36, // 30도 공격 각도 (원거리라 좁음)
    ATTACK_SECTORS: 1, // 부채꼴 시각화 세그먼트 수
    SHOW_ATTACK_VISUAL: true, // 부채꼴 범위 표시 여부
    ATTACK_DAMAGE: 10,
    ATTACK_COOLTIME: 1.5,
    MAX_HEALTH: 100,
    HIT_STUN_DURATION: 0.4, // 피격 경직 시간
    HIT_FLASH_DURATION: 0.25, // 피격 깜빡임 시간
    DEATH_ANIMATION_DURATION: 1.2, // 죽음 애니메이션 시간
    SCALE: 1.0, // 모델 크기
    MODEL_PATH: "models/adventurers/Characters/gltf/Rogue_Hooded.glb",
    FOLLOW_DISTANCE: 6.0, // 플레이어로부터 유지할 거리
  },
  MAGE: {
    NAME: "마법사",
    MOVE_SPEED: 0.035, // 플레이어보다 약간 느림
    COLLIDER_RADIUS: 0.4,
    ATTACK_RANGE: 5.0,
    ATTACK_ANGLE: Math.PI * 2,
    ATTACK_SECTORS: 18, // 부채꼴 시각화 세그먼트 수
    SHOW_ATTACK_VISUAL: true, // 부채꼴 범위 표시 여부
    ATTACK_DAMAGE: 1,
    ATTACK_COOLTIME: 1,
    MAX_HEALTH: 150,
    HIT_STUN_DURATION: 0.4, // 피격 경직 시간
    HIT_FLASH_DURATION: 0.25, // 피격 깜빡임 시간
    DEATH_ANIMATION_DURATION: 1.3, // 죽음 애니메이션 시간
    SCALE: 1.0, // 모델 크기
    MODEL_PATH: "models/adventurers/Characters/gltf/Mage.glb",
    FOLLOW_DISTANCE: 5, // 플레이어로부터 유지할 거리
    // 힐 관련 설정
    HEAL_AMOUNT: 0.5, // 힐 회복량
    HEAL_COOLTIME: 0.1, // 힐 쿨타임 (공격보다 조금 길게)
  },
  BARBARIAN: {
    NAME: "바바리안",
    MOVE_SPEED: 0.045, // 플레이어보다 약간 빠름
    COLLIDER_RADIUS: 0.5,
    ATTACK_RANGE: 2, // 근접 공격
    ATTACK_ANGLE: Math.PI * 2, // 60도 공격 각도
    ATTACK_SECTORS: 100, // 부채꼴 시각화 세그먼트 수
    SHOW_ATTACK_VISUAL: true, // 부채꼴 범위 표시 여부
    ATTACK_DAMAGE: 10,
    ATTACK_COOLTIME: 1.0,
    MAX_HEALTH: 200,
    HIT_STUN_DURATION: 0.4, // 피격 경직 시간 (체력이 높아서 짧음)
    HIT_FLASH_DURATION: 0.2, // 피격 깜빡임 시간
    DEATH_ANIMATION_DURATION: 1.0, // 죽음 애니메이션 시간
    SCALE: 1.2, // 모델 크기
    MODEL_PATH: "models/adventurers/Characters/gltf/Barbarian.glb",
    FOLLOW_DISTANCE: 7, // 플레이어와 가까이 유지
  },
};

// webpack 빌드를 위해 default export 추가
export default CompanionsConfig;

// 전역 변수로도 등록 (기존 코드 호환성)
window.CompanionsConfig = CompanionsConfig;
